import { sdClient } from 'contexts/SDKClientContext';
import {
    BaseUseCollectionOptions,
    useQueryCollection,
} from 'custom_hooks/data_hooks/useQueryCollection';

export const treeItemsQueryKey = 'initial-tree-items';

export function useTreeItems(
    groupIds: string[] | undefined,
    { errorHandling }: Pick<BaseUseCollectionOptions, 'errorHandling'> = {},
) {
    return useQueryCollection({
        queryName: treeItemsQueryKey,
        itemIds: groupIds ?? [],
        itemQuery: (groupId) => sdClient.getTreeItem({ treeItemId: groupId }),
        errorHandling,
    });
}
